import { useMutation, useQueryClient } from "@tanstack/react-query";
import { documentsApi } from "../../api/documentsApi";
import { DOCUMENT_QUERY_KEY } from "./useDocument";
import { DOCUMENTS_QUERY_KEY } from "./useDocuments";
export var useDocumentStatus = function (documentId) {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (decision) {
            return documentsApi.updateStatus(documentId, decision);
        },
        onSuccess: function () {
            queryClient.invalidateQueries({ queryKey: [DOCUMENT_QUERY_KEY, documentId] });
            queryClient.invalidateQueries({ queryKey: [DOCUMENTS_QUERY_KEY] });
        },
    });
};
export var useDocumentMessage = function (documentId) {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (message) {
            return documentsApi.updateMessage(documentId, message);
        },
        onSuccess: function () {
            queryClient.invalidateQueries({ queryKey: [DOCUMENT_QUERY_KEY, documentId] });
        },
    });
};
